/**
 * Validate phone number for authentication
 */
export const validatePhoneNumber = (phoneNumber: string): boolean => {
    const trimmed = phoneNumber?.trim()
  if (!trimmed) return false
  return !!trimmed && trimmed.trim() !== ''
}
